import { Component, Input, OnInit } from '@angular/core';
import { SettingsProvider } from '@services/settings/settings';

@Component({
	selector: 'quote-info',
	template: require('./quote-info.html'),
	styles: [require('./quote-info.scss')]
})
export class QuoteInfoComponent implements OnInit {
	@Input('data') data;
	dateFormat: string;

	constructor(private settingsService: SettingsProvider) {}

	ngOnInit() {
		this.settingsService.timeFormatSettings.subscribe(data => {
			this.dateFormat =
				data.dateFormat === 'DD_MM_YYYY' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/quote/common/quote-info/quote-info.ts